import { render, staticRenderFns } from "./dealer-name-marquee-footer.vue?vue&type=template&id=6cfdbe66&scoped=true&"
import script from "./dealer-name-marquee-footer.vue?vue&type=script&lang=js&"
export * from "./dealer-name-marquee-footer.vue?vue&type=script&lang=js&"
import style0 from "./dealer-name-marquee-footer.vue?vue&type=style&index=0&id=6cfdbe66&lang=scss&scoped=true&"
import style1 from "./dealer-name-marquee-footer.vue?vue&type=style&index=1&id=6cfdbe66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cfdbe66",
  null
  
)

export default component.exports